export class DeviceStartFailureHandled extends Error {
  constructor() {
    super("device start failed (state already set by joinMeeting)");
    this.name = "DeviceStartFailureHandled";
  }
}
